import React from 'react';
import { ZdsBackdrop, ZdsSpinner } from '@zig-design-system/ui-components-react';
import './LoadingSpinner.scss';
const LoadingSpinner = ({ fullscreen = false }) => {
    if (fullscreen) {
        return (React.createElement("div", { className: "loading-spinner--full-screen" },
            React.createElement(ZdsBackdrop, { show: true }),
            React.createElement(ZdsSpinner, { indeterminate: true })));
    }
    return (React.createElement("div", { className: "zds-flex zds-justify-content-center zds-margin-top-6" },
        React.createElement(ZdsSpinner, { indeterminate: true })));
};
export default LoadingSpinner;
